import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export const getFormattedDate = (
  date: string,
  formatDate: string = "DD/MM/YYYY"
) => {
  if (!date) {
    return "-";
  }
  const newDate = new Date(date);
  if (!dayjs(newDate).isValid()) {
    return "Invalid Date";
  }
  return `${dayjs.utc(newDate).format(formatDate)}`;
};

export const getFormattedDecimal = (value: number | string, decimalPlaces: number = 2): string => {
  if (value === null || value === undefined || value === '') return '-';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '-';
  return num
    .toFixed(decimalPlaces)
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.') // miles
    .replace(/\.(\d{2})$/, ',$1'); // decimales
};
